module.exports = __webpack_public_path__ + "assets/img/twitter_b.cecd6a1c.svg";